export default __webpack_public_path__ + "static/ballerina-xs-410938022764dbfac989096736b1e64c.png";